/**
 * @deprecated This entire file is deprecated. Use TypographyV2.tsx instead.
 *
 * The new TypographyV2 components follow a Tailwind-style naming convention
 * that maps directly to the design system tokens:
 *
 * Pattern: Text{Size}{Weight}
 * - Sizes: Xs, Sm, Md, Base, Xl, 2xl, 3xl, 4xl, 5xl, 6xl
 * - Weights: Light, Regular, Medium, Semibold, Bold, Extrabold
 *
 * Example migrations:
 * - Title → Text2xlBold or Text3xlBold
 * - H3 → TextXlBold
 * - SoftHeader → TextXsRegular with color="secondary"
 * - RegularText → TextMdRegular with color="secondary"
 *
 * @see TypographyV2.tsx for the new design system typography components
 */
import styled from "styled-components/macro";

/**
 * @deprecated Use Text2xlBold or Text3xlBold from TypographyV2.tsx instead
 */
export const Title = styled.h1`
  /* 36px */
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.resolve("font_size_2xl")};
  font-weight: ${({ theme }) => theme.fontWeights.large};
  color: ${({ theme }) => theme.primaryTextColor};
`;

/**
 * @deprecated Use TextXsRegular with color="secondary" from TypographyV2.tsx instead
 */
export const SoftHeader = styled.h6`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.secondaryTextColor};
  margin-block-start: ${({ theme }) => theme.resolve("spacing_none")};
  margin-block-end: ${({ theme }) => theme.resolve("spacing_none")};
`;

/**
 * @deprecated Use TextXsMedium with color="secondary" from TypographyV2.tsx instead
 */
export const SoftHeaderMediumWeight = styled(SoftHeader)`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

/**
 * @deprecated Use TextSmRegular with color="secondary" from TypographyV2.tsx instead
 */
export const SoftHeader2 = styled(SoftHeader)`
  font-size: ${({ theme }) => theme.fontSizes.small};
`;

/**
 * @deprecated Use TextMdRegular with color="secondary" from TypographyV2.tsx instead
 */
export const SoftHeaderMedium = styled(SoftHeader)`
  font-size: ${({ theme }) => theme.fontSizes.medium};
`;

/**
 * @deprecated Use TextMdRegular from TypographyV2.tsx instead
 */
export const SoftHeaderMediumDarkText = styled(SoftHeaderMedium)`
  color: ${({ theme }) => theme.primaryButtonTextColor};
`;

/**
 * @deprecated Use TextMdRegular with color="secondary" from TypographyV2.tsx instead
 */
export const SoftHeaderRegular = styled(SoftHeader)`
  font-size: ${({ theme }) => theme.fontSizes.regular};
`;

/**
 * @deprecated Use TextXsRegular from TypographyV2.tsx instead
 */
export const SoftHeaderPrimaryTextColor = styled(SoftHeader)`
  color: ${({ theme }) => theme.primaryTextColor};
`;

/**
 * @deprecated Use TextXlMedium from TypographyV2.tsx instead
 */
export const H4 = styled(SoftHeader)`
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.tertiaryBG};
`;

/**
 * @deprecated Use TextXlRegular from TypographyV2.tsx instead
 */
export const H4Normal = styled(H4)`
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

/**
 * @deprecated Use TextMdMedium from TypographyV2.tsx instead
 */
export const H5 = styled(SoftHeader)`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.tertiaryBG};
`;

/**
 * @deprecated Use TextMdRegular from TypographyV2.tsx instead
 */
export const H5Normal = styled(H5)`
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

/**
 * @deprecated Use TextMdMedium with color="error" from TypographyV2.tsx instead
 */
export const DestructiveText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.destructiveTextColor};
`;

/**
 * @deprecated Use TextMdRegular from TypographyV2.tsx instead
 */
export const H6 = styled(SoftHeader)`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.tertiaryBG};
`;

/**
 * @deprecated Use TextMdBold from TypographyV2.tsx instead
 */
export const H6Bold = styled(H6)`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.large};
`;

/**
 * @deprecated Use TextXlBold from TypographyV2.tsx instead
 */
export const H3 = styled.h3`
  /* 19px */
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.large};
  color: ${({ theme }) => theme.primaryTextColor};
`;

/**
 * @deprecated Use TextSmBold from TypographyV2.tsx instead
 * 13px height
 */
export const SmallSectionHeader = styled(H3)`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizes.small};
  /* font-weight: ${({ theme }) => theme.fontWeights.large}; */
  color: ${({ theme }) => theme.primaryTextColor};
`;

/**
 * @deprecated Use TextSmRegular from TypographyV2.tsx instead
 */
export const SmallSectionHeaderRegular = styled(SmallSectionHeader)`
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

/**
 * @deprecated Use Text2xlBold from TypographyV2.tsx instead
 */
export const H3DarkText = styled(H3)`
  font-size: ${({ theme }) => theme.fontSizes["xl-small"]};
  color: ${({ theme }) => theme.colors.darkText};
`;

/**
 * @deprecated Use Text2xlBold from TypographyV2.tsx instead
 */
export const XLTitle = styled(Title)`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeights.xl};
`;

/**
 * @deprecated Use Text2xlRegular from TypographyV2.tsx instead
 */
export const XLTitleRegularWeight = styled(Title)`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

/**
 * @deprecated Use Text2xlRegular from TypographyV2.tsx instead
 */
export const LargeTitleRegularWeight = styled(Title)`
  font-size: ${({ theme }) => theme.fontSizes["xl-small"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

/**
 * @deprecated Use Text5xlBold from TypographyV2.tsx instead
 */
export const XL4Title = styled(Title)`
  font-size: ${({ theme }) => theme.fontSizes["xl-4"]};
`;

/**
 * @deprecated Use TextXsRegular with color="error" from TypographyV2.tsx instead
 */
export const FormInputErrorText = styled.span`
  color: ${({ theme }) => theme.errorColor};
  font-size: ${({ theme }) => theme.resolve("font_size_xs")};
  line-height: 10px;
  display: block;
`;

/**
 * @deprecated Use TextXsRegular with color="warning" from TypographyV2.tsx instead
 */
export const FormInputWarnText = styled.span`
  color: ${({ theme }) => theme.warningTextColor};
  font-size: ${({ theme }) => theme.resolve("font_size_xs")};
  line-height: 10px;
`;

/**
 * @deprecated Use Text component from TypographyV2.tsx with as="p" instead
 */
export const StyledP = styled.p`
  white-space: pre-wrap;
  width: 100%;
  margin: 0;
`;

/**
 * @deprecated Use TextSmRegular from TypographyV2.tsx instead
 */
export const SmallText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
`;

/**
 * @deprecated Use TextMdRegular with color="secondary" from TypographyV2.tsx instead
 */
export const RegularText = styled.span`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.secondaryTextColor};
`;

/**
 * @deprecated Use TextSmRegular with color="secondary" from TypographyV2.tsx instead
 */
export const RegularTextSmall = styled(RegularText)`
  font-size: ${({ theme }) => theme.fontSizes.small};
`;

/**
 * @deprecated Use TextMdRegular with color="secondary" and as="p" from TypographyV2.tsx instead
 */
export const RegularParagraph = styled.p`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.secondaryTextColor};
`;

/**
 * @deprecated Use TextXlBold from TypographyV2.tsx instead
 */
export const InnerTitle = styled.p`
  color: ${({ theme }) => theme.primaryTextColor};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
`;

/**
 * @deprecated Use TextMdRegular with color="brand" from TypographyV2.tsx instead, with custom link styles
 */
export const ClickableLink = styled.a<{ disabled?: boolean }>`
  padding: ${({ theme }) => theme.resolve("spacing_none")};
  cursor: pointer;
  :hover {
    text-decoration: ${({ disabled }) => (disabled ? "none" : "underline")};
  }
  pointer-events: ${({ disabled }) => (disabled ? "none" : "underline")};
  color: ${({ disabled, theme }) =>
    disabled
      ? `${theme.disabledLinkColor} !important`
      : theme.primaryLinkHover};
`;

/**
 * @deprecated Use TextMdRegular with color="brand" from TypographyV2.tsx instead, with custom link and overflow styles
 */
export const ClickableLinkOverflow = styled(ClickableLink)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
`;

/**
 * @deprecated Use TextSmRegular with color="secondary" from TypographyV2.tsx instead
 */
export const InnerTitleText = styled.div`
  color: ${({ theme }) => theme.secondaryTextColor};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.resolve("font_size_sm")};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: right;
`;

/**
 * @deprecated Use TextSmRegular from TypographyV2.tsx instead
 */
export const SubheaderContentText = styled.div`
  color: ${({ theme }) => theme.primaryTextColor};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.resolve("font_size_sm")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_medium")};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  margin: ${({ theme }) => theme.resolve("spacing_none")};
`;

export const TitleSpan = styled.span`
  color: ${({ theme }) => theme.resolve("color_text_primary")};
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_semibold")};
  line-height: ${({ theme }) => theme.resolve("line_height_md")};
`;
